import _ from 'lodash/fp'

export const getAuth = _.get('auth')

export const getIsLogged = _.flow(_.get('auth.id'), _.negate(_.isNil))

export const getToken = _.get('auth.token')

export const getAllowedBooks = _.get('auth.allowedBooks')
